import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — the hip corner: the roof turns 90 degrees. Two sloped panes
// meet on a diagonal hip running from the ridge apex at the tile centre down
// to the outer eave corner (-X, +Z): one pane slopes down toward +Z (the
// X-ridge run), the other down toward -X (the Z-ridge run). Ridge cap stubs
// carry the ridge out to the +X edge (along X) and the -Z edge (along Z), so
// the piece mates with roof-gable tiles at +X and with 90-degree-rotated
// gable tiles at -Z. Eaves at y=0; the consumer lifts it onto 2.6 m walls.
const SHINGLE = "#4a4a4e";
const RIDGE = "#5a5a5e";

const RISE = 0.8;
const RUN = 0.5;
const PITCH = Math.atan2(RISE, RUN);
const PANE_LEN = Math.hypot(RISE, RUN);

export const roofHipCorner = defineModel({
  id: "roof-hip-corner",
  batchId: "modern",
  name: "Hip roof corner",
  tags: ["modern", "outdoor", "structure", "roof"],
  summary: "A hip corner turning a ridge along X into a ridge along Z.",
  description:
    "The hip corner of the Modern Living kit: two shingle panes meeting on " +
    "a diagonal hip, turning an X ridge (mating a roof-gable at +X) into a " +
    "Z ridge (mating a rotated roof-gable at -Z). Same 0.8 rise and pitch " +
    "as roof-gable. Eaves at y=0; the consumer lifts it onto 2.6 m walls.",
  tiles: { w: 1, h: 1 },
  footprint: 0.9,
  parts(): Part[] {
    return [
      // Pane of the X-ridge run: slopes down toward +Z, eave at z=+0.5.
      { geometry: new THREE.BoxGeometry(1.0, 0.06, PANE_LEN), color: SHINGLE,
        position: [0, RISE / 2, RUN / 2], rotation: [PITCH, 0, 0] },
      // Pane of the Z-ridge run: slopes down toward -X, eave at x=-0.5.
      { geometry: new THREE.BoxGeometry(PANE_LEN, 0.06, 1.0), color: SHINGLE,
        position: [-RUN / 2, RISE / 2, 0], rotation: [0, 0, PITCH] },
      // Ridge cap stubs meeting at the apex: along X to the +X edge...
      { geometry: new THREE.BoxGeometry(0.5, 0.05, 0.14), color: RIDGE,
        position: [0.25, RISE + 0.02, 0] },
      // ...and along Z to the -Z edge.
      { geometry: new THREE.BoxGeometry(0.14, 0.05, 0.5), color: RIDGE,
        position: [0, RISE + 0.02, -0.25] },
    ];
  },
  animations: [],
});
